export default __webpack_public_path__ + "static/media/Education-Big.0e665791.png";